/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import classnames from 'classnames';
import * as React from 'react';

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IAadGenericData } from './aad-generic.data';
import { IAadGenericProps } from './aad-generic.props.autogenerated';

export interface IAadGenericViewProps extends IAadGenericProps<IAadGenericData> {
    aadGeneric: IModuleProps;
    aadConainer: INodeProps;
    aadAPIConainer: React.ReactNode;
    heading?: React.ReactNode;
}

/**
 *
 * AadGeneric component
 * @extends {React.PureComponent<IAadGenericProps<IAadGenericData>>}
 */
class AadGeneric extends React.PureComponent<IAadGenericProps<IAadGenericData>> {
    private moduleClassName: string = 'ms-aad-generic';

    public componentDidMount(): void {
        // @ts-ignore
        const { $i2e, $element } = window || {};

        if ($i2e && $element) {
            $i2e.insertServiceContent($element.getElementContent());
            $element.initialize();
        }
    }

    public shouldComponentUpdate(nextProps:IAadGenericViewProps): boolean {

        if(nextProps.config.heading !== this.props.config.heading) {
            return true;
        }
        return false;
    }

    public render(): JSX.Element | null {
        const { className, heading } = this.props.config;

        const viewProps = {
            ...this.props,
            aadGeneric: {
                moduleProps: this.props,
                className: classnames(this.moduleClassName, className)
            },
            aadConainer: {
                className: `${this.moduleClassName}__container`
            },
            aadAPIConainer: <div id='api' />,
            heading: heading && <Msdyn365.Text className={`${this.moduleClassName}__heading`} {...heading} editProps={{ onEdit: this.handleHeadingChange, requestContext: this.props.context.request }} />
        };

        return this.props.renderView(viewProps);
    }

    public handleHeadingChange = (event: Msdyn365.ContentEditableEvent) => {
        if (this.props.config.heading) {
            this.props.config.heading.text = event.target.value;
        }
    }
}

export default AadGeneric;
